import React from "react";
import { useNotify } from "react-admin";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  styled,
} from "@mui/material";

import QuickAddDropdown from "./QuickAddDropdown";
import {
  store,
  SET_COMMENT_SCROLL,
  SET_LOADING,
  SET_QUICK_CREATE_TARGET,
} from "./store";
import { getCookie } from "../../helpers/Cookies";
import { createOrderItem } from "./sharedMethods";

const comboRegex = /(.*)x(\d{1,}$)/i;

// Styled Box to replace makeStyles root spacing
const FormBox = styled(Box)(({ theme }) => ({
  "& > *": {
    margin: theme.spacing(1),
  },
}));

const QuickAddModal = () => {
  const token = getCookie("token");
  const notify = useNotify();

  const { dispatch, state } = React.useContext(store);
  const { loading, quickCreateTarget } = state;
  const { id: commentId, from, message } = quickCreateTarget || {};

  const [itemDesc, setItemDesc] = React.useState("");
  const [price, setPrice] = React.useState(0);

  const handleClose = React.useCallback(() => {
    dispatch({ type: SET_QUICK_CREATE_TARGET, payload: null });
  }, [dispatch]);

  React.useEffect(() => {
    dispatch({ type: SET_COMMENT_SCROLL, payload: false });
    return () => {
      dispatch({ type: SET_COMMENT_SCROLL, payload: true });
    };
  }, [dispatch]);

  const submitOrders = React.useCallback(() => {
    dispatch({ type: SET_LOADING, payload: true });

    const matches = comboRegex.exec(itemDesc);
    let quantity = 1;
    let description = itemDesc;

    if (matches) {
      description = matches[1].trim();
      quantity = parseInt(matches[2]);
    }

    const payload = {
      data: {
        orders: [
          {
            description,
            quantity,
            price,
            psid: from.id,
            customerName: from.name,
            commentId,
          },
        ],
      },
    };

    createOrderItem({ token, payload })
      .then(() => {
        notify("Quick create successfully");
        dispatch({ type: SET_LOADING, payload: false });
        handleClose();
      })
      .catch(() => {
        notify("Error: quick create failed", { type: "warning" });
        dispatch({ type: SET_LOADING, payload: false });
      });
  }, [token, itemDesc, price, dispatch, notify, handleClose, from, commentId]);

  if (!quickCreateTarget) return null;

  return (
    <Dialog
      open={!!quickCreateTarget}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {`Quick create for ${from.name}`}
      </DialogTitle>
      <DialogContent>
        <FormBox component="form" noValidate autoComplete="off">
          <QuickAddDropdown
            itemDesc={itemDesc}
            setItemDesc={setItemDesc}
            price={price}
            setPrice={setPrice}
          />
          <TextField
            label="Price"
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </FormBox>
        <DialogContentText>{`Comment: ${message}`}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={submitOrders} color="primary" disabled={loading}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuickAddModal;
